<!-- 
 * @description: 中药诊断弹框
 * @author: 翠山 
 * @date: 2021-02-24 16:51:38 
 * @后台人员: 冬枣 
!-->
<template>
  <div class="noprescription paddingtop">
    <h2 style="text-align:center;">诊断</h2>
    <div class="diagnose-box">
      <van-search
        class="diagnose-box_input"
        v-model="searchVal"
        placeholder="关键词搜索诊断"
        shape="round"
        background="#F7F7F7"
        @input="diagnosticsFun"
      >
      </van-search>
    </div>
    <div class="tag-box">
      <h2>常用诊断</h2>
      <div class="tag-list">
        <span
          v-for="(item,index) of taglist"
          :key="index"
          :class="{classactive: isTags(item)}"
          @click="selectTag(item.diagnosisName,item.diagnosisCode)"
        >
          {{ item.diagnosisName }}
        </span>
      </div>
      <!--快速搜索-->
      <div v-show="ifshow" class="search-main"> 
        <ul v-if="datalist.length > 0" class="search-list">
          <li v-for="(item,index) in datalist" :key="index" @click="handClickLabel(item.diagnosisName,item.diagnosisCooe, index)">
            {{ item.diagnosisName.toLowerCase().indexOf(searchVal.toLowerCase())!==-1 ? item.diagnosisName.slice(0,item.diagnosisName.toLowerCase().indexOf(searchVal.toLowerCase())):'' }}
            <span style="color:#EF4D4D">{{ item.diagnosisName.slice(item.diagnosisName.toLowerCase().indexOf(searchVal.toLowerCase()),item.diagnosisName.toLowerCase().indexOf(searchVal.toLowerCase())+searchVal.length) }}</span>
            {{ item.diagnosisName.toLowerCase().indexOf(searchVal.toLowerCase())!==-1 ? item.diagnosisName.substr(item.diagnosisName.toLowerCase().indexOf(searchVal.toLowerCase())+searchVal.length):item.diagnosisName }}
          </li>
        </ul>
        <div v-else class="search-empty">
          <div>
            <van-image width="160" height="130" round :src="require('@/icons/result-empty.png')" />
            <p>暂无搜索结果</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { diagnosticsHotV2, diagnostics } from '@/api/index'
import { getCookie } from '@/utils/auth'
export default {
  props: {
    unActive:Function,
    callback: Function, // 完成回调
    diacrisisProps: String, // 病情描述
    selectedList: Array, // 已选病情描述
  },
  data() {
    return {
      butcolor: '#018BFF', // 按钮颜色
      searchVal: '', // 搜索值
      ifshow: false, // 判断搜索列表显示层
      pageNum: 1,
      pageSize: 1000,
      taglist: [], // 常用标签数据
      datalist: [], // 搜索数据
      tagNames: localStorage.getItem('tagNames') ? localStorage.getItem('tagNames').split() : [], // 获取选中tag的name
      diseaseCooes: localStorage.getItem('diseaseCooes') ? localStorage.getItem('diseaseCooes').split() : []
    }
  },
  watch: {
    searchVal(val) {
      if (val === '') {
        this.ifshow = false
      }
    }
  },
  created() {
    // this.tagNames = this.selectedList;
    if (this.selectedList.length > 0) {
      this.selectedList.forEach(v => {
        if(v.active===true){
          this.tagNames.push(v.diagnosisName);
          this.diseaseCooes.push(v.diagnosisCode);  
        }
        
      })
    }
    this.diagnosticsHotFun()
  },
  methods: {
    handleResize() {
      if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
        window.setTimeout(function() {
          document.activeElement.scrollIntoViewIfNeeded();
        },0);
      }
    },
    // 获取常用诊断数据
    async diagnosticsFun() {
      if (this.searchVal === '') {
        return
      }
      const params = {
        diagnosticName: this.searchVal,
        diagnosisType:1,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      diagnostics(params).then(res => {
        this.datalist = res.data.list.map(item=>{
          return {
            diagnosisCooe:item.diagnosticCooe,
            diagnosisName:item.diagnosticName
          }
        })
        this.dlength = res.data.list.length
        this.ifshow = true
        window.webSdk.track('ds_diagnosis_search_page_app', {
          organSign: getCookie('native_organSign'),
          keyWord: this.searchVal,
          resultNum: this.dlength
        })
      })
    },
    // 获取常用诊断数据
    async diagnosticsHotFun() {
      diagnosticsHotV2({diagnosisType:1}).then(res => {
        this.taglist = res.result.map(item=>{
          return {
            diagnosisName:item.diagnosticName,
            diagnosisCode:item.diagnosticCooe,
            diseaseCooe:item.diseaseCooe
          }
        })
        
      })
    },
    // 删除选择标签 
    // deleteSelectTag(tagName) {
    //   for (let i = 0; i < this.tagNames.length; i++) {
    //     if (tagName === this.tagNames[i]) {
    //       window.webSdk.track('ds_Del_diagnosis_click_app', {
    //         organSign: getCookie('native_organSign'),
    //         delTagName: tagName
    //       })
    //       this.tagNames.splice(i, 1)
    //       this.diseaseCooes.splice(i, 1)
    //       // this.diseaseCooes = []
    //     }
    //   }
    // },
    // 标签选择
    selectTag(tagName, diseaseCode) {
      const flag = this.tagNames.indexOf(tagName) === -1 
      if (flag&&this.tagNames.length >= 5) {
        Toast('常用诊断不能超过5个')
        return false
      }
      if (flag&&this.tagNames.join('|').length + tagName.length > 50) {
        Toast('诊断字数超限')
        return false
      }
      window.webSdk.track('diagnosisCn', {
        diagnosisCode: diseaseCode,
        diagnosisName:tagName
      })
      // this.tagNames.length = 0
      // this.diseaseCooes.length = 0
      // 去掉上句注释，则代表单选，不去掉注释，则代表多选
      if (this.tagNames.indexOf(tagName) === -1) { // 在当前数组中找不到该选项
        this.tagNames.push(tagName)
      } else {
        this.tagNames.splice(this.tagNames.indexOf(tagName), 1)
        const index =this.selectedList.findIndex(item=>{
          return item.diagnosisName === tagName
        })
        this.$emit('unActive',index)
      }

      if (this.diseaseCooes.indexOf(diseaseCode) === -1) { // 在当前数组中找不到该选项
        this.diseaseCooes.push(diseaseCode)
      } else {
        this.diseaseCooes.splice(this.diseaseCooes.indexOf(diseaseCode), 1)
      }
      this.onCompelete(true)
    },
    // 标签选择样式控制
    isTags(item) {
      return (this.tagNames.indexOf(item.diagnosisName) !== -1)
    },
    // 点击搜索列表
    handClickLabel(tagName, diagnosisCooe, index) {
      const flag = this.tagNames.indexOf(tagName) === -1
      if ((this.tagNames.join('|').length + tagName.length > 50)&&flag) {
        Toast('诊断字数超限')
        this.hideSearchList()
        return false
      }
      if ((this.tagNames.length >= 5)&&flag) {
        Toast('诊断不能超过5个')
        this.hideSearchList()
        return false
      }
      if(!flag){
        this.$toast({
          message:'您已添加过该诊断'
        })
        this.searchVal = ''
        return false
      }
      window.webSdk.track('ds_diagnosis_search_click_app', {
        organSign: getCookie('native_organSign'),
        keyWord: this.searchVal,
        resultNum: this.dlength,
        select: tagName,
        seq: index
      })
      // this.tagNames.length = 0
      // this.diseaseCooes.length = 0
      // 去掉上句注释，则代表单选，不去掉注释，则代表多选
      if (this.tagNames.indexOf(tagName) === -1) { // 在当前数组中找不到该选项
        this.tagNames.push(tagName)
        this.hideSearchList()
      } else {
        this.tagNames.splice(this.tagNames.indexOf(tagName), 1)
      }
      if (this.diseaseCooes.indexOf(diagnosisCooe) === -1) { // 在当前数组中找不到该选项
        this.diseaseCooes.push(diagnosisCooe)
        this.hideSearchList()
      } else {
        this.diseaseCooes.splice(this.diseaseCooes.indexOf(diagnosisCooe), 1)
      }
      this.onCompelete(true)
    },
    // 隐藏搜索列表
    hideSearchList() {
      this.ifshow = false
      this.searchVal = ''
    },
    // 完成病情描述并返回
    onCompelete(flag) {
      this.callback && this.callback(flag ? this.getObject() : '')
    },
    // 拼装诊断对象
    getObject() {
      let arr = []
      this.diseaseCooes.forEach((v, i) => {
        arr.push({
          diagnosisCode: v,
          diagnosisName: this.tagNames[i],
          diagnosisType:3,
          active:true
        })
      })
      return arr;
    }
  }
}
</script>
<style scoped lang="scss">
#root .search-box {
  height: auto;
}
.van-cell{
  min-height:auto!important;
  padding:5px 0 5px 5px!important;
}
.noprescription > h2 {
  padding: 15px;
  font-size: 16px;
  margin: 0;
}
.diagnose-box {
  padding: 0 15px;
  width: 100%;
  position:absolute;
  z-index: 9999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  .diagnose-box_input {
    flex: 1;
    padding: 0;
    background: #fff !important;
    .van-search__content {
      background: #f7f8fa;
    }
  }
}
.tag-box{
  height: 420px;
  position: relative;
  padding:0 15px;
  margin-top:30px;
  overflow: auto;
  padding-bottom:20px;
  box-sizing: border-box;
}
.tag-box h2{
  font-size: 16px;
  margin:0;
  padding-top:20px;
  padding-bottom: 5px;
  color: #333;
}
.tag-list span{
  background:#F8F8F8;
  border-radius:16px;
  border:1px solid transparent;
  font-size:14px;
  font-weight:400;
  display: inline-block;
  padding:5px 16px;
  margin:10px 10px 0px 0;
}
.tag-list span.classactive{
  background:#f3faff;
  border:1px solid #01B956;
  color:#01B956;
}
.choice-tag-list span{
  border-radius:16px;
  border:1px solid rgba(227,227,227,1);
  font-size:14px;
  font-weight:400;
  display: inline-block;
  padding:5px 30px 5px 16px;
  margin:10px 10px 0px 0;
  position: relative;
}
.choice-tag-list span em{
  display: block;
  width:16px;
  height: 16px;
  background: url('../../icons/search-dell.png') no-repeat 0 center;
  background-size:16px 16px;
  position: absolute;
  top:8px;
  right:8px;
}
.search-main{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 99;
  padding:0 30px;
  box-sizing: border-box;
  overflow-y: auto;
  .search-list {
    height: 100%;
    overflow-y: scroll;
    li {
      border-bottom: 1px solid #EDEDED;
      padding:9px 0;
      font-size:15px;
      color: #333;
    }
  }
  .search-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #999;
    font-size: 15px;
  }
}
.footerbut {
  padding: 15px 20px;
  /deep/ .van-button__text {
    font-size: 18px;
  }
}
</style>
